export default "__VITE_ASSET__CMq6KJNY__"